/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { Image } from '..'
import { API_IMAGE_OBJECT } from '../../utils/types'
import styles from './styles'

const Puff = ({ link, image }) => {
  const [errorCaught, setErrorCaught] = useState(false)
  if (errorCaught) return null
  return (
    <li className="Puff" onError={() => setErrorCaught(true)}>
      <a href={link}>
        <Image image={image} />
      </a>
      <style jsx>{styles}</style>
    </li>
  )
}

Puff.propTypes = exact({
  link: PropTypes.string.isRequired,
  image: API_IMAGE_OBJECT.isRequired,
})

export default Puff
